angular.module('aprima-core-ui').factory('ScrollerService', ['_', function (_) {
    'use strict';

    var scroller = {};

    return {
        getScroller: function (id) {
            return scroller[id];
        },
        addScroller: function (id, easyScroller, updatePageFn) {
            scroller[id] = _.cloneDeep(easyScroller);
            if(updatePageFn) {
                scroller[id].scrollTo = function(left, top, animate) {
                    updatePageFn();
                    easyScroller.scrollTo(left, top, animate);
                };
            }
        },
        removeScroller: function (id) {
            scroller[id] = undefined;
        }
    };
}]);
